export const PERSONAL_DETAILS_MOCK = {
  firstName: 'John',
  lastName: 'Doe',
  phone: '1234567890',
  email: 'johnsnow@ukr.net',
  preferredContactMethod: null,
  firstNameHolder: 'Jane',
  lastNameHolder: 'Phillips',
  phoneHolder: '0987654321',
};
